var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLlava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    style: {
      flex: "none",
      lineHeight: 1
    },
    viewBox: "0 0 24 24",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LLaVA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.976 11.91s-.055-2.284 1.1-3.644c1.154-1.359 2.638-2.393 3.572-3.045.935-.652 2.254-1.469 2.089-2.637-.165-1.17-1.088-1.945-5.1-1.945s-6.77.369-9.327 1.7c-2.556 1.332-1.472 3.054-.384 3.345.96.257 2.183.36 3.152 1.383 1.758 1.853 1.573 4.707 1.573 4.707l3.325.136z",
    fill: "url(#lobe-icons-l-la-va-0-_R_0_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38 12.834s-3.132 4.297-3.958 5.358c-.826 1.06-2.528 2.8-2.417 3.017.11.217 1.402.734 1.402.734s6.54.924 7.061.924c.522 0 11.239-3.017 11.239-3.017s-3.764-7.968-4.975-7.506c-1.21.463-8.352.49-8.352.49z",
    fill: "#717578"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.491 15.39s-.934.815-1.373 1.251c-.44.437-1.67 1.415-1.51 1.577.13.133 1.987-.702 2.18-.798.166-.081 2.216-.835 2.353-.643.137.191-.46.643-.659.924-.185.261-3.458 3.524-4.231 3.725-.556.146-3.93.327-4.04.054-.111-.27 1.208-2.12.88-2.393-.33-.272-1.678.603-2.474 1.066-.795.462-2.032 1.054-2.225 1.082-.193.028-.385-.028-.385-.028s-.058.34 1.65 1.114c1.345.61 2.445 1.17 6.129 1.523 3.683.353 6.32.028 7.858-.191 1.54-.218 4.369-1.089 5.112-1.414.741-.326 1.315-.663 1.237-.896-.028-.082-4.314-5.71-4.314-5.71l-2.313-3.396-3.875 3.152z",
    fill: "#474B4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79 9.829c-.855.126-1.16 1.086-2.05 2.206-.513.646-.952 1.084-1.196 1.38-.274.332-.637 1.018-.274 1.211.362.193.922-.384 1.075-.703.152-.317.377-.642.589-.419.211.223.225.612-.317 1.06-.543.449-1.178.971-1.117 1.435.06.465.376.598.739.493.362-.104 1.238-1.106 1.57-1.599.333-.492.86-1.345 1.223-1.345.363 0 .357.747-.362 1.584-.83.967-1.235 1.302-2.22 2.183-1.023.913-.89 1.24-.709 1.419.182.18.695.223 1.434-.403.74-.628 1.783-1.807 2.236-2.332.453-.522.86-1.09 1.33-1.06.468.03.346.492.406.718.06.223.06.641.618.641s.86-.568 1.042-1.016c.18-.449.165-1.046.527-1.106.363-.06.407.299.695.867.286.568 1.39 2.927 1.662 3.346.272.419.574 1.21 1.464.94.89-.268-.256-1.897-.528-2.301-.272-.403-1.057-1.764-1.36-2.675-.301-.91-.301-1.196-.104-1.345.195-.15.528.269.967 1.076.437.807.816 1.555 1.162 1.854.346.299.648.269.8.133.15-.133.211-.642-.182-1.03a11.076 11.076 0 01-1.259-1.537 42.745 42.745 0 01-1.488-2.396c-.362-.627-.57-1.058-1.063-1.134-.639-.097-1.098.375-1.46.628-.363.253-.86.389-1.36.359-.498-.03-1.162-.568-1.434-.807-.27-.235-.542-.399-1.055-.325z",
    fill: "url(#lobe-icons-l-la-va-1-_R_0_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.236 10.638s.342.072.592.257c.25.186.864.682 1.663.67.8-.01 1.245-.39 1.567-.576.323-.185.623-.154.623-.154s-.542 2.091-2.151 2.153c-2.105.082-2.294-2.35-2.294-2.35z",
    fill: "#EC5F32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.242 10.921c-.294.042-.141.459-.1 1.443.043.985.033 1.4.506 1.401.593.002.407-1.235.294-1.61-.11-.375-.346-1.284-.7-1.234z",
    fill: "url(#lobe-icons-l-la-va-2-_R_0_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.171 6.12c-.129.255.28.542.659.985.255.3.63 1.04 1.15 1.096.52.055.58-.562.322-.917-.252-.347-.687-.694-1.178-.943-.49-.249-.854-.416-.953-.221z",
    fill: "url(#lobe-icons-l-la-va-3-_R_0_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.539 3.649c.155.07.308-.028.364-.236.037-.137.657-1.134 1.571-1.747.743-.5 1.094-.5 1.473-.652.23-.094.435-.445.322-.708-.107-.25-.337-.346-.715-.29-.24.035-1.114.256-1.978 1.18-1.065 1.137-1.122 1.928-1.15 2.066-.028.138-.036.319.113.387z",
    fill: "url(#lobe-icons-l-la-va-4-_R_0_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.49 3.774c-.288.076-.533-.333-1.05-.86-.52-.529-.982-.597-1.236-.918-.253-.32-.209-.68.015-.874.223-.194.616-.222.966.041s.8.764 1.122 1.457c.175.375.451 1.084.183 1.154z",
    fill: "url(#lobe-icons-l-la-va-5-_R_0_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68 5.89c-.203-.189-1.012.146-1.633.662-.296.246-.594.537-.717.842-.102.259-.098.587.143.747.218.143.484.076.67-.066.255-.197.432-.594.581-.813.262-.383.697-.747.84-.869.13-.114.27-.36.117-.502z",
    fill: "url(#lobe-icons-l-la-va-6-_R_0_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.352 11.13c-.234-.071-.585.182-.879 1.294-.26.984-.34 1.871.315 1.887.688.018.402-.974.483-1.87.08-.894.314-1.24.08-1.31z",
    fill: "url(#lobe-icons-l-la-va-7-_R_0_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29 9.839c.384.076.585-.213.664-.478.062-.212.326-1.312 1.7-1.435 1.329-.12 2.28 1.203 2.417 1.349.138.145.32.171.422.068.091-.09.073-.255-.018-.479-.094-.239-1.192-2.106-3.142-1.861-1.847.231-2.485 1.64-2.469 2.178.014.377.123.598.425.658z",
    fill: "url(#lobe-icons-l-la-va-8-_R_0_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.046 9.598c.25.082.367-.194.457-.323.091-.13.572-1.042 1.428-1.479.858-.436 1.503-.484 2.31-.121.43.193.732.715.915 1.034.246.428.588.542.914.363.327-.178.375-.712-.106-1.35-.39-.516-1.26-1.397-2.802-1.243-2.457.243-3.12 2.373-3.184 2.577-.07.235-.103.486.068.542z",
    fill: "url(#lobe-icons-l-la-va-9-_R_0_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.862 10.058c.256.026.322-.086.393-.524.16-.987.409-2.85 1.73-4.357 1.043-1.19 2.217-1.046 2.735-.727.453.279.564.546.747.74.183.193.552.424.882.193.276-.192.345-.68-.135-1.214-.479-.534-.968-.97-2.17-1.068-1.203-.098-2.391.667-3.03 1.59-.638.923-1.104 2.232-1.25 3.12-.148.886-.16 1.673-.16 1.857 0 .18.049.368.258.39z",
    fill: "url(#lobe-icons-l-la-va-10-_R_0_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.837 10.06c.268-.04.306-.243.27-.558-.037-.315-.276-2.047-.756-3.394-.477-1.347-1.2-2.603-2.612-2.864-1.41-.261-2.531.72-2.689.881-.245.253-.501.676-.195 1.016.306.341.802.076 1.12-.265.318-.34.854-.805 1.726-.538.87.267 1.283 1.074 1.664 1.84.38.765.682 1.867.841 2.45.16.581.26 1.042.323 1.213.062.16.185.237.308.22z",
    fill: "url(#lobe-icons-l-la-va-11-_R_0_)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "48.297%",
    cy: "102.258%",
    fx: "48.297%",
    fy: "102.258%",
    gradientTransform: "matrix(.7039 0 0 1 .143 0)",
    id: "lobe-icons-l-la-va-0-_R_0_",
    r: "94.548%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "17.43%",
    stopColor: "#E79F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "27.76%",
    stopColor: "#E6A272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45.28%",
    stopColor: "#E3AB8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.12%",
    stopColor: "#E2AF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78.33%",
    stopColor: "#E1D1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88.28%",
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "46.574%",
    cy: "-17.021%",
    fx: "46.574%",
    fy: "-17.021%",
    gradientTransform: "matrix(0 1 -.7313 0 .341 -.636)",
    id: "lobe-icons-l-la-va-1-_R_0_",
    r: "104.429%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "38.96%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.16%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66.46%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71.53%",
    stopColor: "#EA5B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79.21%",
    stopColor: "#EA6032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "88.7%",
    stopColor: "#EC6F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96.72%",
    stopColor: "#ED823A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-27.509%",
    cy: "-21.261%",
    fx: "-27.509%",
    fy: "-21.261%",
    gradientTransform: "matrix(1 0 0 .35 0 -.138)",
    id: "lobe-icons-l-la-va-2-_R_0_",
    r: "247.627%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.48%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34.39%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.12%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-29.546%",
    cy: "-14.202%",
    fx: "-29.546%",
    fy: "-14.202%",
    gradientTransform: "matrix(.9419 0 0 1 -.017 0)",
    id: "lobe-icons-l-la-va-3-_R_0_",
    r: "145.983%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "29.39%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.49%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "89%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-1.091%",
    cy: "131.876%",
    fx: "-1.091%",
    fy: "131.876%",
    gradientTransform: "matrix(.9434 0 0 1 0 0)",
    id: "lobe-icons-l-la-va-4-_R_0_",
    r: "130.022%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.48%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34.39%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.12%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "127.538%",
    cy: "131.898%",
    fx: "127.538%",
    fy: "131.898%",
    gradientTransform: "matrix(1 0 0 .914 0 .113)",
    id: "lobe-icons-l-la-va-5-_R_0_",
    r: "149.345%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "42.32%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60.38%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.02%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "129.457%",
    cy: "-24.912%",
    fx: "129.457%",
    fy: "-24.912%",
    gradientTransform: "matrix(.9605 0 0 1 .051 0)",
    id: "lobe-icons-l-la-va-6-_R_0_",
    r: "139.942%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "34.06%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54.7%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "89.73%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "95.294%",
    cy: "-40.37%",
    fx: "95.294%",
    fy: "-40.37%",
    gradientTransform: "matrix(1 0 0 .3667 0 -.256)",
    id: "lobe-icons-l-la-va-7-_R_0_",
    r: "328.308%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "48.33%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.51%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.95%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.033%",
    cy: "50.021%",
    fx: "50.033%",
    fy: "50.021%",
    gradientTransform: "matrix(.5045 0 0 1 .248 0)",
    id: "lobe-icons-l-la-va-8-_R_0_",
    r: "78.647%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.48%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34.39%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.12%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.024%",
    cy: "50.007%",
    fx: "50.024%",
    fy: "50.007%",
    gradientTransform: "matrix(.4925 0 0 1 .254 0)",
    id: "lobe-icons-l-la-va-9-_R_0_",
    r: "80.209%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.48%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34.39%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.12%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-46.282%",
    cy: "44.724%",
    fx: "-46.282%",
    fy: "44.724%",
    gradientTransform: "matrix(1 0 0 .9988 0 0)",
    id: "lobe-icons-l-la-va-10-_R_0_",
    r: "121.766%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "39.43%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "58.39%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90.57%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "137.282%",
    cy: "79.026%",
    fx: "137.282%",
    fy: "79.026%",
    gradientTransform: "matrix(1 0 0 .9331 0 .053)",
    id: "lobe-icons-l-la-va-11-_R_0_",
    r: "126.759%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "42.05%",
    stopColor: "#CB2D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60.19%",
    stopColor: "#D23730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90.97%",
    stopColor: "#E45231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EA5B31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlava);
export default __webpack_public_path__ + "static/media/llava.3eaaac93164a93d1f50a3cc6e5c4dc3c.svg";
export { ForwardRef as ReactComponent };